export default __webpack_public_path__ + "static/media/brand-hort-colour.df6f3b8c.svg";